module.exports = "/images/logo/ne-logo2.jpg";